import type { PublicSlotKey } from '#packages/apilib';
import type { FixedStageApi } from './api';

export const FixedStageApiKey: PublicSlotKey<FixedStageApi> = {
  name: 'FixedStageApi',
  public: true,
};
